document.addEventListener("DOMContentLoaded", function() {
  
  // ---------------------------------------------------------
  // Adaptación: Buscamos SOLO dentro de esta sección ID
  // ---------------------------------------------------------
  // We find all featured-collection sections and init each independently
  document.querySelectorAll('[id^="shopify-section-"]').forEach(function(sectionContainer) {
    // Only target sections that contain a featured-collection-wrapper
    if (!sectionContainer.querySelector('.featured-collection-wrapper')) return;

    // =========================================================
    // 1. GESTIÓN INTELIGENTE DE FLECHAS (Visibilidad + Estado + Scroll 1 a 1)
    // =========================================================
    function initArrowLogic() {
      const sliders = sectionContainer.querySelectorAll('slider-component');

      sliders.forEach(component => {
        const slider = component.querySelector('ul.slider');
        if (!slider) return;

        const items = slider.querySelectorAll('li.grid__item');
        
        // Adaptación: Usamos sectionContainer como referencia de la sección
        const buttonsContainer = sectionContainer.querySelector('.slider-buttons');
        const prevBtn = sectionContainer.querySelector('button[name="previous"]');
        const nextBtn = sectionContainer.querySelector('button[name="next"]');

        // --- A. OCULTAR EN MÓVIL ---
        if (window.innerWidth < 990) {
          if (buttonsContainer) buttonsContainer.style.display = 'none';
          return; 
        }

        // --- B. OCULTAR SI HAY POCOS PRODUCTOS ---
        if (buttonsContainer) {
          if (items.length <= 5) {
            buttonsContainer.style.setProperty('display', 'none', 'important');
          } else {
            buttonsContainer.style.setProperty('display', 'flex', 'important');
          }
        }

        // --- C. DETECTAR FIN/INICIO DEL SCROLL ---
        const updateArrowState = () => {
          if (!prevBtn || !nextBtn) return;

          const tolerance = 2;
          const scrollLeft = slider.scrollLeft;
          const maxScroll = slider.scrollWidth - slider.clientWidth;

          if (scrollLeft <= tolerance) {
            prevBtn.setAttribute('disabled', 'true');
          } else {
            prevBtn.removeAttribute('disabled');
          }

          if (scrollLeft >= maxScroll - tolerance) {
            nextBtn.setAttribute('disabled', 'true');
          } else {
            nextBtn.removeAttribute('disabled');
          }
        };

        updateArrowState();

        // --- D. ACTIVAR SCROLL MANUAL (UNO A UNO) ---
        const getScrollDistance = () => {
          const item = slider.querySelector('li.grid__item');
          if (!item) return slider.clientWidth;
          const itemWidth = item.offsetWidth;
          const gapStyle = window.getComputedStyle(slider).columnGap;
          const gap = parseFloat(gapStyle) || 0; 
          return itemWidth + gap;
        };

        if (prevBtn) {
          prevBtn.onclick = function(e) {
            e.preventDefault();
            const distance = getScrollDistance();
            slider.scrollBy({ left: -distance, behavior: 'smooth' });
            setTimeout(updateArrowState, 500);
          };
        }
        if (nextBtn) {
          nextBtn.onclick = function(e) {
            e.preventDefault();
            const distance = getScrollDistance();
            slider.scrollBy({ left: distance, behavior: 'smooth' });
            setTimeout(updateArrowState, 500);
          };
        }

        slider.addEventListener('scroll', updateArrowState);
        window.addEventListener('resize', updateArrowState);
        if (prevBtn) prevBtn.addEventListener('click', () => setTimeout(updateArrowState, 300));
        if (nextBtn) nextBtn.addEventListener('click', () => setTimeout(updateArrowState, 300));
      });
    }

    initArrowLogic();
    window.addEventListener('resize', initArrowLogic);

    // =========================================================
    // 2. DRAG & DROP (ARRASTRE FLUIDO) - INTACTO
    // =========================================================
    const dragSliders = sectionContainer.querySelectorAll('.slider-mobile-gutter .slider');

    dragSliders.forEach(slider => {
      let isDown = false;
      let startX;
      let scrollLeft;
      let isDragging = false; 

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        isDragging = false; 
        slider.classList.add('active');
        slider.style.scrollSnapType = 'none';
        slider.style.scrollBehavior = 'auto';
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      const stopDragging = () => {
        isDown = false;
        slider.classList.remove('active');
        slider.style.scrollSnapType = 'x mandatory';
        slider.style.scrollBehavior = 'smooth';
        setTimeout(() => { isDragging = false; }, 50); 
      };

      slider.addEventListener('mouseleave', stopDragging);
      slider.addEventListener('mouseup', stopDragging);

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault(); 
        const x = e.pageX - slider.offsetLeft;
        if(Math.abs(x - startX) > 5) isDragging = true;
        const walk = (x - startX) * 1; 
        slider.scrollLeft = scrollLeft - walk;
      });

      slider.addEventListener('click', (e) => {
        if (isDragging) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      
      slider.querySelectorAll('a').forEach(link => {
          link.addEventListener('click', (e) => {
              if (isDragging) e.preventDefault();
          });
      });
    });
  });
});
